@if (conversationalChatStore.takeoverError()) {
    <div class="ap-flex ap-flex-1 ap-flex-column ap-height-100 ap-margin-4 ap-text-align-center">
        <ap-error [apError]="conversationalChatStore.takeoverError()"></ap-error>
    </div>
}

@if (conversationalChatStore.showConnectionError()) {
    <conversational-chat-connectionerror class="ap-flex ap-flex-1 ap-flex-column ap-height-100 ap-margin-4 ap-text-align-center">
    </conversational-chat-connectionerror>
}

@if (conversationalChatStore.showRetryConnectionError()) {
    <conversational-chat-retryconnectionerror
        (refreshComponent)="refreshChatComponent()"
        class="ap-flex ap-flex-1 ap-flex-column ap-height-100 ap-margin-4 ap-text-align-center"
    >
    </conversational-chat-retryconnectionerror>
}

@if (conversationalChatStore.showChat()) {
    <div class="ap-flex-fill chat-position-relative">
        @if (conversationalChatStore.showLiveChatFaqPopUp()) {
            <conversational-chat-overlay-message (selectContinueConversation)="hideLiveChatFaqPopUp()" class="ap-width-100">
            </conversational-chat-overlay-message>
        }
        @if (conversationalChatStore.idleTimerActive()) {
            <conversational-chat-inactivityprompt
                (promptSelectContinue)="promptContinueConversation()"
                (promptSelectEnd)="promptEndConversation()"
                class="ap-width-100"
            >
            </conversational-chat-inactivityprompt>
        }

        <div role="status" aria-live="polite" aria-atomic="true" class="ap-sr-only">
            {{ screenreaderService.liveMessage1() }}
        </div>
        <div role="status" aria-live="polite" aria-atomic="true" class="ap-sr-only">
            {{ screenreaderService.liveMessage2() }}
        </div>

        <klant-conversational
            class="ap-flex ap-flex-fill ap-flex-column"
            [messageLoading]="webSocketService.messageLoading()"
            [chatMessages]="conversationalChatStore.chatMessages()"
            [firstMessageWasSent]="klantConversationalConnectorService.firstMessageWasSent"
            (sendAction)="onSendAction($event)"
            (sendMessage)="onSendMessage($event)"
            (firstMessageSent)="klantConversationalConnectorService.onFirstMessageSent($event)"
        >
        </klant-conversational>
    </div>
}
